import React from 'react';
import { colors } from '../../../../theme';
export var Hamburger = function Hamburger(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "1.48315",
    y1: "1.40674",
    x2: "12.827",
    y2: "1.40674",
    stroke: props.color || colors.PRIMARY,
    strokeWidth: props.strokeWidth || '1.5',
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "1.48315",
    y1: "6.40674",
    x2: "12.827",
    y2: "6.40674",
    stroke: props.color || colors.PRIMARY,
    strokeWidth: props.strokeWidth || '1.5',
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "1.48315",
    y1: "11.4067",
    x2: "12.827",
    y2: "11.4067",
    stroke: props.color || colors.PRIMARY,
    strokeWidth: props.strokeWidth || '1.5',
    strokeLinecap: "round"
  }));
};